export const STANDARD_DIALOG_WIDTH = '600px';
export const STANDARD_DIALOG_WIDTH_NUMBER = 600;
